import { createSelector } from "@reduxjs/toolkit";

import { AppState } from "@/redux/store";
import { CountryCode } from "custom-types/CountryCode";

const getConfigState = (state: AppState) => state.config;

export const getDomainCountryCode = createSelector(
  [getConfigState],
  (state) => state.domainCountryCode as CountryCode,
);
